import request from '@/utils/request'

let Metting_aApi = {

  /*维修预约列表*/
  list(data) {
    return request._post('/shop/plus.metting_a.Index/index', data);
},
/*添加维修预约*/
add(data) {
    return request._post('/shop/plus.metting_a.Index/add', data);
},
/*修改维修预约*/
edit(data) {
    return request._post('/shop/plus.metting_a.Index/edit', data);
},
/*删除维修预约*/
del(data) {
    return request._post('/shop/plus.metting_a.Index/del', data);
},
/*维修预约详情*/
detail(data) {
  return request._post('/shop/plus.metting_a.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.metting_a.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.metting_a.Setting/getSetting', data, errorback);
    },
}
export default Metting_aApi;



// WEBPACK FOOTER //
// ./src/api/metting_a.js